import './styles.scss';
import TopDashboardSection from '../../../common/top-dashboard-section';
import AlertMessages from '../../alert-messages';
import l from '../../../../lang';
import ApiHero from './api-hero';
import ApiSolutions from './api-solutions';
import ApiKeysSection from './api-keys-section';

const ApiIntegrationPage = () => {
  return (
    <div className="api_integration_page">
      <TopDashboardSection
        title={l('paymentIntegration.api.page.title')}
        subtitle={l('paymentIntegration.api.page.subtitle')}
      />
      <AlertMessages />
      <div className="api_integration_page__shell">
        <div className="api_integration_page__module api_integration_page__module--hero">
          <ApiHero />
        </div>
        <div className="api_integration_page__module api_integration_page__module--solutions">
          <ApiSolutions />
        </div>
        <div className="api_integration_page__module api_integration_page__module--keys">
          <ApiKeysSection />
        </div>
      </div>
    </div>
  );
};

export default ApiIntegrationPage;
